/**
 * Inquiry validators
 */
import { z } from 'zod';
export const createInquirySchema = z.object({
    show_id: z.string().uuid('Invalid show ID').optional(),
    tour_stop_id: z.string().uuid('Invalid tour stop ID').optional(),
    contact_name: z.string().min(1, 'Name is required').max(100),
    contact_email: z.string().email('Invalid email address').toLowerCase(),
    contact_phone: z.string().max(20).optional(),
    message: z.string().max(2000).optional(),
    preferred_dates: z.array(z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Date must be YYYY-MM-DD format')).max(3, 'Maximum 3 preferred dates').optional(),
    // Hosted class specific fields
    venue_address: z.string().max(500).optional(),
    venue_capacity: z.number().int().min(1).max(1000).optional(),
    // SMS/text-message consent (A2P/10DLC). Optional opt-in checkbox; defaults false.
    sms_consent: z.boolean().optional().default(false),
});
export const adminRespondInquirySchema = z.object({
    response_message: z.string().min(1, 'Response message is required').max(5000),
    status: z.enum(['responded', 'closed']),
    generate_booking_link: z.boolean().default(false),
});
//# sourceMappingURL=inquiry.js.map